module.exports = __webpack_public_path__ + "img/rubyfuza.b17caec6.png";